import { useTranslation } from 'react-i18next';

export default function TradeInPage() {
  const { t } = useTranslation();

  return (
    <div className="page">
      <div className="page-header">
        <h1 className="page-title">
          <i className="fa fa-exchange" /> {t('Trade-In', 'Trade-In')}
        </h1>
      </div>
      <div className="form-card">
        <div className="empty-state">
          <i className="fa fa-exchange" style={{ fontSize: 48, marginBottom: 12, display: 'block', color: 'var(--mod-tradein)' }} />
          <p>Trade-In module — accept and value trade-in items.</p>
          <p className="text-muted">Coming soon</p>
        </div>
      </div>
    </div>
  );
}
